import { Component, Input, OnInit } from '@angular/core';
import { TuningsTextService, TuningText } from '../LIB/services/tunings-text.service';
import { Tuning } from '../LIB/services/tunings.service';

@Component({
  selector: 'app-tuning-text',
  templateUrl: './tuning-text.component.html',
  styleUrls: ['./tuning-text.component.scss'],
})
export class TuningTextComponent implements OnInit {
  @Input() tuning: Tuning;
  constructor(
    public tuningsTextService: TuningsTextService
  ) { }

  ngOnInit() {}
  getTuningTextArray(notesKey: string, preferredNote12: number): TuningText[] {
    const text = this.tuningsTextService.all.find(o =>
      (o.notes === notesKey) &&
      ((typeof(o.preferredNote12) === 'undefined') || (o.preferredNote12 === preferredNote12)));
    if (text) {
      return [text];
    } else {
      return [];
    }
  }
}
